import { trackEvent } from 'modules/analytics';

const riversideLandingPage = 'riverside_landing_page';

const trackRiversideLandingPageView = () => {
  trackEvent(
    null,
    {
      eventCategory: riversideLandingPage,
      eventAction: 'view_page',
      eventLabel: 'riverside_landing_page_view',
    },
    // eslint-disable-next-line
    { providers: [ga] }
  );
};

const trackRiversideSignupClicked = () => {
  trackEvent(
    null,
    {
      eventCategory: riversideLandingPage,
      eventAction: 'sign_up',
      eventLabel: 'riverside_click_sign_up',
    },
    // eslint-disable-next-line
    { providers: [ga] }
  );
};

const trackRiversideLoginClicked = () => {
  trackEvent(
    null,
    {
      eventCategory: riversideLandingPage,
      eventAction: 'log_in',
      eventLabel: 'riverside_click_log_in',
    },
    // eslint-disable-next-line
    { providers: [ga] }
  );
};

const trackRiversideSwitchClicked = () => {
  trackEvent(
    null,
    {
      eventCategory: riversideLandingPage,
      eventAction: 'switch',
      eventLabel: 'riverside_click_switch',
    },
    // eslint-disable-next-line
    { providers: [ga] }
  );
};

const trackRiversideScrollLandingPage = () => {
  trackEvent(
    null,
    {
      eventCategory: riversideLandingPage,
      eventAction: 'scroll',
      eventLabel: 'riverside_scroll_landing_page',
    },
    // eslint-disable-next-line
    { providers: [ga] }
  );
};

export {
  trackRiversideLandingPageView,
  trackRiversideSignupClicked,
  trackRiversideLoginClicked,
  trackRiversideSwitchClicked,
  trackRiversideScrollLandingPage,
};
